/** Thananan OS's one router, moving to a path (set by `startApps`) */
let osNavigate: ((path: string) => void) | null = null
export const setOsNavigate = (navigate: (path: string) => void) => {
  osNavigate = navigate
}

/** Going to another app's page by script (search, a report's group): a move in the one router, no page load */
export function goToApp(href: string) {
  const url = new URL(href, window.location.href)
  if (url.origin !== window.location.origin || !osNavigate) return window.location.assign(href)
  osNavigate(url.pathname + url.search + url.hash)
}

/**
 * A plain link on this site (`<a href={appLink(…)}>`: an app card, a menu item, a page of another app) is a move in the
 * one router too, not a page load; what a router link or a page's own handler took care of is left to it, and so are a
 * new tab (⌘/Ctrl-click, `target`), a download and the API's files
 */
export function followLinks(navigate: (path: string) => void) {
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
    const link = (event.target as Element | null)?.closest?.('a[href]') as HTMLAnchorElement | null
    if (!link || (link.target && link.target !== '_self') || link.hasAttribute('download')) return
    const url = new URL(link.href, window.location.href)
    if (url.origin !== window.location.origin || url.pathname.startsWith('/api/')) return
    event.preventDefault()
    navigate(url.pathname + url.search + url.hash)
  })
}
